import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import RootReducer from "./slices";

const store = configureStore({
  reducer: RootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      immutableCheck: false,
      serializableCheck: false,
    }).concat(thunk),
});

export default store;
